import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

const FAQSection = () => {
  const [countersec, setCounter] = useState([]);
  const [items, setItems] = useState([]);
  const [faq, setFAQsection] = useState([]);
  const [activeIndex, setActiveIndex] = useState(null);


  const [page, setPage] = useState([]);
    const { pageSlug } = useParams(); // Extract the blog post titleSlug from the URL
  
    useEffect(() => {
      fetch(`https://marchtwo202501-5801b8caeb3a.herokuapp.com/page/${pageSlug}`)
        .then((res) => res.json())
        .then((info) => setPage(info))
        .catch((error) => console.error("Error fetching banners:", error));
    }, []);

  // Fetch FAQ section data
  useEffect(() => {
    fetch(`https://marchtwo202501-5801b8caeb3a.herokuapp.com/faq`)
      .then((res) => res.json())
      .then((info) => setFAQsection(info));
  }, []);

  // Fetch FAQ items data
  useEffect(() => {
    fetch(`https://marchtwo202501-5801b8caeb3a.herokuapp.com/faq-items`)
      .then((res) => res.json())
      .then((info) => setItems(info));
  }, []);

  // Fetch counter section data
  useEffect(() => {
    fetch(`https://marchtwo202501-5801b8caeb3a.herokuapp.com/counters`)
      .then((res) => res.json())
      .then((info) => setCounter(info));
  }, []);

  // Accordion toggle handler
  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <><section className="questions" id="faq-sec">
      {
        faq.map(a => a.pageSlug === page.pageSlug &&  <div className="questions__wrapper">
          <div className="container">
            <h2 className="section-heading color-black">{a.faqHeading}</h2>
            <div className="row align-items-lg-center">
              <div className="col-lg-6 order-2 order-lg-1">
                <div id="accordion">
                  {items.map((item, index) =>
                    item.pageSlug === page.pageSlug &&  (
                      <div className="card" key={index}>
                        <div className="card-header" id={`heading-${index}`}>
                          <h5 className="mb-0">
                            <button
                              className={`btn btn-link ${activeIndex === index ? '' : 'collapsed'}`}
                              onClick={() => toggleAccordion(index)}
                              aria-expanded={activeIndex === index}
                              aria-controls={`collapse-${index}`}
                            >
                              {item.accodingTitle}
                            </button>
                          </h5>
                        </div>
                        <div
                          id={`collapse-${index}`}
                          className={`collapse ${activeIndex === index ? 'show' : ''}`}
                          aria-labelledby={`heading-${index}`}
                          data-parent="#accordion"
                        >
                          <div className="card-body">
                            <p className="paragraph">{item.accodingText}</p>
                          </div>
                        </div>
                      </div>
                    )
                  )}

                </div>
              </div>
              <div className="col-lg-6 order-1 order-lg-2">
                <div className="questions-img">
                  <img src={a.faqText} alt="FAQ" />
                </div>
              </div>
            </div>
          </div>
        </div>)
      }

    </section></>
  );
};

export default FAQSection;
